import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.js";
import Spinner from "components/Spinner";
import ComboBox from "components/ComboBox";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(2),
      width: 200,
    },
  },
  newUserButton: {
    display: "flex",
    justifyContent: "center",
  },
}));

export default function EditProductForm({ loading, onEdit, formData, status }) {
  const classes = useStyles();
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  console.log("xxxx data", JSON.stringify(data));
  useEffect(() => {
    formData.listed = formData.listed === true ? 1 : 2;
    setData(formData);
    setErrors({});
    return () => setData({});
  }, [formData]);
  const kvOptions = [
    { key: 1, value: "YES" },
    { key: 2, value: "NO" },
  ];
  const emptyObject = (obj) => {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  };
  const handleListingToggle = (e) => {
    let oldData = { ...data };
    oldData.listed = e.target.value;
    setData(oldData);
  };
  const handleIsUssdProductToggle = (e) => {
    let oldData = { ...data };
    oldData.isUssdProduct = e.target.value;
    setData(oldData);
  };

  const handleClick = () => {
    let errorList = {};
    if (!data.name) errorList.name = "field cannot be empty";
    if (!data.description) errorList.description = "field cannot be empty";
    if (!data.unitPrice) errorList.unitPrice = "field cannot be empty";
    if (data.unitPrice && (isNaN(data.unitPrice) || data.unitPrice < 0.0))
      errorList.unitPrice = "Invalid value for price";
    if (emptyObject(errorList)) {
      let edited = { ...data };
      edited.listed = edited.listed === 1 ? true : false;
      edited.isUssdProduct = edited.isUssdProduct === 1 ? true : false;
      let changes = Object.fromEntries(
        Object.entries(edited).filter(
          ([k, v]) => k === "id" || v !== formData[k]
        )
      );
      onEdit(changes);
    } else setErrors(errorList);
  };
  const checkError = (field) => {
    return errors[field] !== undefined;
  };
  function handleChange(event, name) {
    let oldData = { ...data };
    oldData[name] = event.target.value;
    setData(oldData);
  }
  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div>
        <TextField
          error={checkError("name")}
          label="Product Name"
          id="name"
          value={data.name}
          onChange={(e) => handleChange(e, "name")}
          variant="outlined"
          helperText={errors.name}
          size="small"
        />
        <TextField
          error={checkError("description")}
          label="Description"
          id="description"
          value={data.description}
          onChange={(e) => handleChange(e, "description")}
          variant="outlined"
          helperText={errors.description}
          size="small"
        />
        <TextField
          error={checkError("unitPrice")}
          label="Unit Price"
          id="unitPrice"
          value={data.unitPrice}
          onChange={(e) => handleChange(e, "unitPrice")}
          variant="outlined"
          helperText={errors.unitPrice}
          size="small"
        />
        <ComboBox
          value={data["listed"]}
          label={"List for purchase"}
          onSelect={handleListingToggle}
          kvOptions={kvOptions}
        />
        <ComboBox
          value={data["isUssdProduct"]}
          label={"Is USSD Product"}
          onSelect={handleIsUssdProductToggle}
          kvOptions={kvOptions}
        />
      </div>
      <div></div>
      {loading && <Spinner />}
      {!loading && status === "FAILED" && (
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Update failed!
        </Alert>
      )}
      {!loading && status === "SUCCESS" && (
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          Update successful!
        </Alert>
      )}
      <div className={classes.newUserButton}>
        <Button
          color="primary"
          round
          disabled={loading}
          onClick={() => handleClick(data)}
        >
          Update
        </Button>
      </div>
    </form>
  );
}
EditProductForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
};
